import { alpha, darken, Theme } from '@mui/material';

const Chip = (theme: Theme) => {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 4,
        },
      },
      variants: [{
        props: {
          color: 'primary',
        },
        style: {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.primary.main,
          border: `2px solid ${theme.palette.primary.main}`,
        },
      }, {
        props: {
          color: 'secondary',
        },
        style: {
          backgroundColor: theme.palette.secondary.light,
          color: theme.palette.secondary.dark,
          border: `2px solid ${theme.palette.secondary.main}`,
        },
      }, {
        props: {
          color: 'success',
        },
        style: {
          backgroundColor: alpha(theme.palette.success.light, 0.5),
          color: theme.palette.success.dark,
          border: `2px solid ${theme.palette.success.main}`,
        },
      }, {
        props: {
          color: 'warning',
        },
        style: {
          backgroundColor: alpha(theme.palette.warning.main, 0.5),
          color: theme.palette.warning.dark,
          border: `2px solid ${theme.palette.warning.main}`,
        },
      }, {
        props: {
          color: 'default',
        },
        style: {
          backgroundColor: theme.palette.background.default,
          color: darken(theme.palette.background.default, 0.5),
          border: `2px solid ${theme.palette.grey[400]}`,
        },
      }],
    },
  };
};

export default Chip;
